import { IUnit } from "../interfaces/unit";

export class SpeedUnits {
  static mph: IUnit = { id: 0, display: 'MPH' };
  static kmh: IUnit = { id: 1, display: 'KMH' };

  static getById(id: number) {
    let values = Object.values(SpeedUnits);
    return values[id];
  }

  static speedToMph(speed: number): number {
    return speed * 0.621371
  }

  static speedToKmh(speed: number): number {
    return speed / 0.621371;
  }
}
